export default {
  curveEditor: {
    saveCurrentCurve: '現在の曲線を保存',
    saveCurve: '曲線を保存',
    curveName: '曲線の名前',
    cancel: 'キャンセル',
    confirm: '確定',
    deleteKeyFrame: 'キーフレームを削除',
    auto: '自動',
    freeSmooth: 'フリースムース',
    flat: 'フラット',
    broken: 'ブロークン',
    linear: 'リニア',
    close: '閉じる',
    save: '保存',
    dialogProps: {
      title: '曲線エディタ',
    },
    curveNameIsEmpty: '曲線名は空にできません',
    saveCurveSuccess: '曲線の保存に成功しました',
  },
  animationCollection: {
    play: '再生',
    stop: '停止',
    save: '保存',
    close: '折りたたむ',
    playAllAnimation: 'すべて再生',
    deleteSuccess: '削除に成功しました',
    stopAnimation: '再生を停止',
  },
  animationForm: {
    duration: '持続時間',
    delay: '遅延時間',
    style: 'ループ回数',
    playOnAwake: '自動再生',
    animationName: '名前',
    moveAxis: '移動軸',
    autoEndTime: '自動終了時間',
    loop: 'ループ',
    distanceX: 'X軸距離',
    distanceY: 'Y軸距離',
    rebound: '弾性',
    trialTimes: '試行回数',
  },
  qcPoint: {
    setPointValue: '現在の値に設定',
    positionMap: {
      from: '開始位置',
      to: '終了位置',
    },
    scaleMap: {
      from: '開始比率',
      to: '終了比率',
    },
  },
  animationColor: {
    colorLabel: {
      from: '開始色',
      to: '終了色',
    },
  },
  tweenPosition: {
    show: '終了位置を編集',
    hide: '終了位置を保存',
  },
  circular: {
    once: '1回再生',
    loop: '単方向ループ',
    pingPong: '双方向ループ',
  },
  animationType: {
    base: '一般',
  },
  animationTag: [
    '透明度変化',
    '平行移動表示',
    '現地縮小表示',
    '大きくスライドイン',
    'バウンド表示',
    '展開',
    '現地回転表示',
    'スクロール表示',
    '透明度変化',
    '平行移動非表示',
    '現地縮小表示',
    '小さくスライドアウト',
    'バウンド非表示',
    '折り畳む',
    '現地回転非表示',
    'スクロール非表示',
    '拡大縮小',
    '点滅',
    '往復',
    '弾性',
    '振り子',
    '回転',
    'スライドズーム',
  ],
  tweenLabel: {
    alpha: '透明度',
    position: '移動',
    rotation: '回転角度',
    scale: '拡大縮小',
    color: '色の変化',
  },
  switchAnimation: 'アニメーションの置き換え',
  scriptManager: {
    animationCurve: '曲線の変化',
    handArea: 'ジェスチャーエリア',
  },
  board: 'ジェスチャーエリア',
}
